var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/TreeContext/TreeContext.tsx";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var TreeContext = /*#__PURE__*/React.createContext(null);
export function useTreeContext() {
  return React.useContext(TreeContext);
}
export function useTree() {
  return useTreeContext().tree;
}
export function useNodes() {
  return useTreeContext().nodes;
}
export function useDynamicGroupsConditions() {
  return useTreeContext().dynamicGroupsConditions;
}